import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RecentActivityItem = ({ activity }) => {
  const getActivityIcon = (type) => {
    const icons = {
      'project_update': 'FileText',
      'message': 'MessageSquare',
      'document': 'File',
      'milestone': 'Flag',
      'payment': 'CreditCard',
      'meeting': 'Video',
      'approval': 'CheckCircle',
      'notification': 'Bell'
    };
    return icons?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colors = {
      'project_update': 'bg-primary/10 text-primary',
      'message': 'bg-accent/10 text-accent',
      'document': 'bg-secondary/10 text-secondary',
      'milestone': 'bg-success/10 text-success',
      'payment': 'bg-warning/10 text-warning',
      'meeting': 'bg-primary/10 text-primary',
      'approval': 'bg-success/10 text-success',
      'notification': 'bg-muted text-muted-foreground'
    };
    return colors?.[type] || 'bg-muted text-muted-foreground';
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - activityTime) / (1000 * 60));

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return `${Math.floor(diffInMinutes / 1440)}d ago`;
  };

  return (
    <div className="flex items-start gap-3 md:gap-4 p-3 md:p-4 hover:bg-muted/50 rounded-lg transition-colors duration-200">
      <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${getActivityColor(activity?.type)}`}>
        <Icon name={getActivityIcon(activity?.type)} size={16} className="md:w-5 md:h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <p className="text-xs md:text-sm font-medium text-foreground line-clamp-2">
            {activity?.title}
          </p>
          <span className="text-xs text-muted-foreground whitespace-nowrap flex-shrink-0">
            {formatTimeAgo(activity?.timestamp)}
          </span>
        </div>
        
        <p className="text-xs text-muted-foreground line-clamp-2 mb-2">
          {activity?.description}
        </p>

        {activity?.user && (
          <div className="flex items-center gap-2">
            <Image
              src={activity?.user?.avatar}
              alt={activity?.user?.avatarAlt}
              className="w-5 h-5 md:w-6 md:h-6 rounded-full object-cover"
            />
            <span className="text-xs text-muted-foreground">{activity?.user?.name}</span>
          </div>
        )}

        {activity?.metadata && (
          <div className="flex items-center gap-2 mt-2 text-xs text-muted-foreground">
            {activity?.metadata?.projectName && (
              <>
                <Icon name="Folder" size={12} className="flex-shrink-0" />
                <span className="line-clamp-1">{activity?.metadata?.projectName}</span>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentActivityItem;